<template>
  <div :id="`brand-${$route.params.brand}`" class="brand">
    <Header />
    <template v-if="$route.params.brand == 'force'">
      <Main :mainImg="forceMainImg" />
      <VarietyTabs :tabs="tabs" />
      <SwatchCopyProduct :data="forceSwatchCopyProduct" />
    </template>

    <template v-else-if="$route.params.brand == 'cliff'">
      <Main :mainImg="cliffMainImg" />
      <VarietyTabs :tabs="tabs" />
      <SwatchCopyProduct :data="cliffSwatchCopyProduct" />
    </template>

    <template v-else-if="$route.params.brand == 'classic-milano'">
      <Main :mainImg="classicMilanoMainImg" />
      <VarietyTabs :tabs="tabs" />
      <SwatchCopyProduct :data="classicMilanoSwatchCopyProduct" />
    </template>

    <template v-else-if="$route.params.brand == 'focus'">
      <!-- <Main :mainImg="classicMilanoMainImg" /> -->
      <VarietyTabs :tabs="tabs" />
      <!-- <SwatchCopyProduct :data="classicMilanoSwatchCopyProduct" /> -->
    </template>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";

import Main from '@/components/body/Main.vue';
import VarietyTabs from '@/components/body/VarietyTabs.vue';
import SwatchCopyProduct from '@/components/body/SwatchCopyProduct.vue';

import Footer from "@/components/Footer.vue";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "Brand",

  components: {
    Header,
    Main,
    VarietyTabs,
    SwatchCopyProduct,
    Footer,
  },

  computed: {
    ...mapState({
      axiosWc: state => state.axiosWc,
      tabs: state => state.pages.brand.tabs,
    }),
    ...mapState({
      forceMainImg: state => state.pages.force.mainImg,
      forceVarietyTabs: state => state.pages.force.varietyTabs,
      forceSwatchCopyProduct: state => state.pages.force.swatchCopyProduct,

      cliffMainImg: state => state.pages.force.mainImg,
      cliffVarietyTabs: state => state.pages.cliff.varietyTabs,
      cliffSwatchCopyProduct: state => state.pages.cliff.swatchCopyProduct,

      classicMilanoMainImg: state => state.pages['classic-milano'].mainImg,
      classicMilanoVarietyTabs: state => state.pages['classic-milano'].varietyTabs,
      classicMilanoSwatchCopyProduct: state => state.pages['classic-milano'].swatchCopyProduct,
    }),
    ...mapGetters(['getUrlApi','getBrands']),
  },

  mounted: function () {
    this.SET_DRAWER(false);
    this.SET_CURRENT_TAB(false);
    this.setVarietyTab({ page: this.$route.params.brand });
		this.genuineLeatherSVG().then((res) => {
			switch (this.$route.params.brand) {
				case 'force':
					this.watermarkSVG = res.replace('#000','#705F6A');
					break;

				case 'classic-milano':
					this.watermarkSVG = res.replace('#000','#845F42');
					break;

				case 'cliff':
					this.watermarkSVG = res.replace('#000','#845F42');
					break;

				default:
					break;
			}
		});
  },

  methods: {
    ...mapActions(['genuineLeatherSVG','setVarietyTab']),
    ...mapMutations(['SET_DRAWER','SET_CURRENT_TAB']),
  },
}
</script>

<style lang="scss">
</style>